<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>配置<span style="color:#409EFF;">{{currentFactor.displayName}}</span>相关因子</template>

  <template #body>
    <el-form ref="form" :model="model">
      <el-row
        v-for="(relatedFactor, index) in model.relatedFactors"
        :key="index"
        :gutter="gutter"
      >
        <el-col :span="8">
          <el-form-item
            label="相关因子"
            :prop="`relatedFactors[${index}].relatedFactorId`"
            :rules="[{
              required: true,
              message: '请选择相关因子'
            }]"
          >
            <el-cascader
              v-model="relatedFactor.relatedFactorId"
              :options="factorTrees[index]"
              :show-all-levels="false"
              :props="{
                expandTrigger: 'click',
                value: 'id',
                label: 'name',
                emitPath: false
              }"
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="相关系数下限"
            :prop="`relatedFactors[${index}].relatedLow`"
            :rules="[{
              required: true,
              message: '请输入相关系数下限'
            }]"
          >
            <el-input v-model="relatedFactor.relatedLow" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="相关系数上限"
            :prop="`relatedFactors[${index}].relatedHigh`"
            :rules="[{
              required: true,
              message: '请输入相关系数上限'
            }]"
          >
            <el-input v-model="relatedFactor.relatedHigh" type="number" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" plain class="btn save-continue-btn" @click="onCreateRelatedFactorBtnClick">新增相关因子</el-button>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'RelatedFactorEditor',
  extends: BaseEditor,
  props: {
    currentFactor: {
      required: true,
      type: Object
    }
  },
  computed: {
    apiKey () {
      return 'RelatedFactor'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return ''
    },
    editName () {
      return '相关因子'
    },
    filterFactors () {
      let {id} = this.currentFactor
      return this.factors.filter(factor => factor.id !== id)
    },
    factorTrees () {
      let relatedFactorIds = this.model.relatedFactors.map(relatedFactorData => relatedFactorData.relatedFactorId)

      return relatedFactorIds.map((relatedFactorId, index) => {
        let filterRelatedFactorIds = [...relatedFactorIds]
        filterRelatedFactorIds.splice(index, 1)

        let relatedFactorIdMap = filterRelatedFactorIds.reduce((map, relatedFactorId) => {
          map[relatedFactorId] = true
          return map
        }, {})

        let factors = JSON.parse(JSON.stringify(this.filterFactors))
        let factorGroupMap = JSON.parse(JSON.stringify(this.factorGroupMap))
        let filterFactors = factors.filter(factor => !relatedFactorIdMap[factor.id])
        let roots = []

        for (let i = 0; i < filterFactors.length; i++) {
          let item = filterFactors[i]
          let {parentId} = item

          if (parentId) {
            let parent = factorGroupMap[parentId]

            if (!parent) {
              continue
            }

            let {children} = parent

            if (!Array.isArray(children)) {
              children = parent.children = []
              filterFactors.push(parent)
            }

            children.push(item)
          } else {
            roots.push(item)
          }
        }

        return roots
      })
    }
  },
  methods: {
    initModel () {
      return {
        factorId: this.currentFactor.id,
        relatedFactors: [this.getRelatedFactorModel()]
      }
    },
    getRelatedFactorModel () {
      return {
        factorId: this.currentFactor.id,
        relatedFactorId: null,
        relatedLow: null,
        relatedHigh: null
      }
    },
    afterGetDetail (model) {
      let {relatedFactors} = model

      if (relatedFactors.length === 0) {
        relatedFactors.push(this.getRelatedFactorModel())
      }
    },
    onCreateRelatedFactorBtnClick () {
      this.model.relatedFactors.push(this.getRelatedFactorModel())
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/04Factor/RelatedFactorEditor.vue